@let tPrefix = 'features.session.recording.exportDialog';

<ng-container *transloco="let t">
  <h2 mat-dialog-title>{{ t(`${tPrefix}.title`) }}</h2>

  <form #formDirective="ngForm" [formGroup]="form" (submit)="save()">
    <mat-dialog-content>
      <app-mind-datetime
        class="w-100"
        [control]="startedAtControl"
        [label]="t('features.session.list.headers.startedAt')"
        [required]="true"
      />

      <mat-form-field class="w-100">
        <mat-label>{{ t(`${tPrefix}.participant`) }}</mat-label>

        <mat-select [formControl]="participantControl">
          @for (option of data.participants; track option.mindDeviceId) {
            <mat-option [value]="option.mindDeviceId">
              {{ `${option.participantName} (${option.mindDeviceName})` }}
            </mat-option>
          }
        </mat-select>

        <mat-error>
          {{ participantControl.errors | validatorError }}
        </mat-error>
      </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="center">
      @let exportInProgressValue = exportInProgress();

      <button
        data-testid="submit-button"
        matButton="filled"
        type="submit"
        [disabled]="(formDirective.invalid && formDirective.submitted) || exportInProgressValue"
      >
        @if (exportInProgressValue) {
          <mat-icon>
            <mat-spinner diameter="16" />
          </mat-icon>
        }

        {{ t('features.session.recording.export') }}
      </button>

      <button data-testid="cancel-button" mat-button type="button" (click)="cancel()">
        {{ t('common.cancel') }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-container>
